import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ValueProposition from '../components/ValueProposition';
import Sectors from '../components/Sectors';
import Technology from '../components/Technology';
import Products from '../components/Products';
import Scale from '../components/Scale';
import HowItWorks from '../components/HowItWorks';
import CompetitiveAdvantages from '../components/CompetitiveAdvantages';
import WhyQubo from '../components/WhyQubo';
import BusinessModel from '../components/BusinessModel';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <ValueProposition />
      <Sectors />
      <Technology />
      <Products />
      <Scale />
      <HowItWorks />
      <CompetitiveAdvantages />
      <WhyQubo />
      <BusinessModel />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
